import { useContext } from 'react';
import { NotificationContext } from './firebase_messaging_provider';

/**
 * Hook to access notification context.
 * error that should only occur during development when the hook is used incorrectly.
 */
export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotification must be used within FirebaseMessagingProvider');
  }

  return context;
};
